import { IReportLocalLotacao } from '@/api.types';

export type GrupoDefensoriasLotacao = {
  diretoriaId: number | null;
  diretoriaNome: string | null;
  predioId: number | null;
  defensorias: IReportLocalLotacao[];
};

export function montarGruposDefensorias(
  defensoriasFiltradas: IReportLocalLotacao[],
  agruparPorDiretoria: boolean,
  agruparPorPredio: boolean,
  ordenarDefensorias: (items: IReportLocalLotacao[]) => IReportLocalLotacao[],
): GrupoDefensoriasLotacao[] {
  if (!agruparPorDiretoria && !agruparPorPredio) {
    return [{
      diretoriaId: null,
      diretoriaNome: null,
      predioId: null,
      defensorias: ordenarDefensorias(defensoriasFiltradas),
    }];
  }

  const gruposMap = new Map<string, GrupoDefensoriasLotacao>();

  defensoriasFiltradas.forEach((defensoria) => {
    const diretoriaId = agruparPorDiretoria ? (defensoria.diretoria_id ?? 0) : null;
    const diretoriaNome = agruparPorDiretoria
      ? (defensoria.diretoria_nome ?? 'Sem diretoria')
      : null;
    const predioId = agruparPorPredio ? (defensoria.predio_id ?? 0) : null;
    const key = `${diretoriaId ?? 'x'}-${predioId ?? 'x'}`;

    if (!gruposMap.has(key)) {
      gruposMap.set(key, {
        diretoriaId,
        diretoriaNome,
        predioId,
        defensorias: [],
      });
    }

    gruposMap.get(key)!.defensorias.push(defensoria);
  });

  return Array.from(gruposMap.values())
    .map((grupo) => ({
      ...grupo,
      defensorias: ordenarDefensorias(grupo.defensorias),
    }))
    .sort((a, b) => {
      const cmpDiretoria = (a.diretoriaNome ?? '').localeCompare(b.diretoriaNome ?? '', 'pt-BR');
      if (cmpDiretoria !== 0) return cmpDiretoria;
      return (a.predioId ?? 0) - (b.predioId ?? 0);
    });
}
